export default __webpack_public_path__ + "static/media/640_business03-it-mobile.488a8018.png";